const mutations = {
  SET_COPIES_PAGINATION (state, data) {
    let paginationInfo = JSON.parse(JSON.stringify(data))
    if (paginationInfo.total_elements <= 30 ) {
      paginationInfo.total_pages = 1
    } else {
      paginationInfo.total_pages = Math.trunc(paginationInfo.total_elements/30)+1
    }
    state.pagination = {
      ...state.pagination,
      ...paginationInfo
    }
  },
  SET_COPIES_LIST (state, data) {
    state.items = JSON.parse(JSON.stringify(data))
  },
  SET_COPY_TO_EDIT (state, data) {
    const copyInfo = JSON.parse(JSON.stringify(data))
    state.copyToEdit = {
      ...state.copyToEdit,
      ...copyInfo
    }
  },
  UNSET_COPY_TO_EDIT (state, data) {
    state.copyToEdit = {
      copy_id: null,
      copy_name: '',
      product: {
        product_id: null,
        product_name: '',
        product_owner_name: '',
        product_is_active: null,
        product_updated_at: ''
      },
      copy_is_active: true,
      copy_updated_at: ''
    }
  },
  SET_PAGE (state, data) {
    state.page = data
  },
  SET_PAGE_SIZE (state, data) {
    state.size = data
  },
  SET_STATUS_FILTER (state, data) {
    state.is_active = data
  },
  SET_PRODUCT_FILTER (state, data) {
    state.product_id = data
  },
  SET_LOADING (state, data) {
    state.loading = data
  }
}

export default mutations


// WEBPACK FOOTER //
// ./src/store/modules/copy/mutations.js